import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"


import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
// import { deleteSingleCategories, getAllCategories } from "../../assets/api/super-admin"
import { toast } from "react-toastify"

import Loading from "../../components/loading/loading"

import { ReactComponent as Edit } from "../../assets/icons/generals/Edit.svg"
import { ReactComponent as Delete } from "../../assets/icons/generals/Delete.svg"
import { ReactComponent as View } from "../../assets/icons/generals/view.svg"

import { useRequestProcessor } from "../../api/requestProcessor"
import { deleteSingleCategory, getAllCategories } from "../../api/categories"
import { confirmAlert } from "react-confirm-alert"
import Pagination from "../../components/pagination/pagination"



const Categories = () => {

    const naviagte = useNavigate()
    const [activeTab, setActiveTab] = useState(0)
    const [page, setPage] = useState(1)
    const [searchKeyword, setSearchKeyword] = useState("")


    async function onDeleteHandler(data, type) {
        confirmAlert({
            overlayClassName: "modalBackDrop-bg",
            customUI: ({ onClose }) => {
                return (
                    <div className='bg-white wsm:w-full w-[750px] py-8 px-4 rounded-xl font-bold'>
                        <h1 className=" text-center pb-4">
                            {"آیا از حذف " + type + " " + data.title + " مطمعن هستید؟"}
                        </h1>
                        <div className="flex justify-around ">

                            <button className="" onClick={onClose}>خیر</button>
                            <button className="border-2 text-red-500 rounded-lg py-3 !px-5 border-red-500"
                                onClick={() => { deleteMutate(data.id); onClose() }}>
                                بله
                            </button>
                        </div>
                    </div>
                );
            }
        })
    }

    const { Query, Mutate } = useRequestProcessor()

    const { data, isLoading, isError, refetch } = Query(
        ['getAllCategories', searchKeyword],
        () => getAllCategories(searchKeyword),
        { enabled: Boolean(searchKeyword) || searchKeyword == "" }
    );

    const { mutate: deleteMutate } = Mutate(
        "deleteBlog",
        deleteSingleCategory,
        {
            onSuccess: (data) => {
                toast.success(data.message)//This is the response you get back
                refetch()
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );

    function setTabHandler(data) {
        switch (data) {
            case 0:
                setActiveTab(data)
                setSearchKeyword("")
                break;
            case 1:
                setActiveTab(data)
                setSearchKeyword("blogs")
                break;
            case 2:
                setActiveTab(data)
                setSearchKeyword("workshops")
                break;
            case 3:
                setActiveTab(data)
                setSearchKeyword("courses")
                break;

            default:
                break;
        }
    }

    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };


    return (
        <Layout>
            <MainPageLayout title={"دسته بندی ها"} buttonTitle={"دسته بندی جدید"} buttonLink={"/admin/categories/create"} >
                <div className="flex justify-between py-3 items-center  wsm:flex-col-reverse">
                    <div onChange className="flex [&>*]:px-4 [&>*]:py-1 p-2 bg-[#eef3f7] rounded-lg text-[#5e6278]">
                        <button onClick={() => setTabHandler(0)} className={activeTab === 0 ? "bg-white rounded-lg text-black" : ""}>همه</button>
                        <button onClick={() => setTabHandler(1)} className={activeTab === 1 ? "bg-white rounded-lg text-black" : ""}>بلاگ ها</button>
                        <button onClick={() => setTabHandler(2)} className={activeTab === 2 ? "bg-white rounded-lg text-black" : ""}>ورک شاپ ها</button>
                        <button onClick={() => setTabHandler(3)} className={activeTab === 3 ? "bg-white rounded-lg text-black" : ""}>دوره ها</button>
                    </div>
                    {/* <div className="flex wsm:mb-4">

                        <input type="text" className='form-input !w-full' value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                            placeholder='جستوجو دسته بندی ها ...' />

                        <span className="flex text-sky-500 font-serif items-center mr-3 cursor-pointer">
                            <Filter width={24} height={24} />
                            فیلتر
                        </span>
                    </div> */}
                </div>
                <table className="table-auto transition-all" >
                    <thead className="!py-2">
                        <tr className=" border-b border-black">
                            <th className="py-3">#</th>
                            <th className="py-3">عنوان</th>
                            <th className="py-3">نوع</th>
                            <th className="py-3">عملیات</th>
                        </tr>
                    </thead>
                    {
                        !isLoading &&
                        <tbody>
                            {
                                data?.data?.length ?
                                    data?.data?.map(el => (
                                        <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                            <td className="text-center py-5" >{el.id}</td>
                                            <td className="text-center py-5" > {el.title}</td>
                                            <td className="text-center py-5 " >
                                                <div className="bg-[#2196f3] py-2 text-white rounded-[1rem]">
                                                    {el.type === "blog" ? "بلاگ" : el.type === "workshop" ? "ورک شاپ" : "دوره"}
                                                </div>
                                            </td>
                                            <td className="text-center py-5" >
                                                <div className="flex justify-evenly items-center">
                                                    <div className=" cursor-pointer" onClick={() => naviagte("/admin/categories/" + el.id)}><View width={"20"} height="20" /></div>
                                                    <div className=" cursor-pointer" onClick={() => naviagte("/admin/categories/edit/" + el.id)}><Edit width={"20"} height="20" /></div>
                                                    <div className=" cursor-pointer" onClick={() => { onDeleteHandler(el, "دسته بندی") }} ><Delete width={"20"} height="20" /></div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <div>
                                        <p>هیچ دسته بندی پیدا نشد</p>
                                    </div>
                            }
                        </tbody>
                    }
                </table>
                {
                    isLoading && <Loading />
                }
                {data?.meta?.last_page > 1 && <Pagination handlePageClick={handlePageClick} lastPage={data?.meta?.last_page} />}

            </MainPageLayout>
        </Layout>
        // <Layout>

        //     {isDeleteModalOpen && <ConfirmDeleteModal deleteHandler={onDeleteHandler} type={"دسته بندی"} data={selectedData} onConfirm={onConfirm} />}

        //     <div className='transaction-container'>
        //         <div className='transaction-record-sidebox '>
        //             <div className='transaction-detail-container shadow-xl'>
        //                 <CustomSideBars link="/super-admin/categories/create" title="ایجاد دسته بندی جدید" />
        //             </div>
        //             <div className='transaction-filter-box shadow-xl'>
        //                 <div className='filter-input-container'>
        //                     <p>جستجو :</p>
        //                     <div>
        //                         <input type="text" className='input-handler' value={searchKeyword}  onChange={(e) => setSearchKeyword(e.target.value)} placeholder=' جستوجو دسته بندی با نام ...' />
        //                     </div>
        //                 </div>
        //                 <p id='reset-btn' onClick={()=>setSearchKeyword("")}>حذف فیلتر ها</p>
        //             </div>
        //         </div>
        //         <div className="transaction-list-container active-primary-box  !min-h-[75%] !h-full">
        //             <div className='border rounded-[1.5rem] p-6 flex flex-col h-full'>
        //                 <h1 className="font-bold text-[1.125rem] mb-2">مشاهده دسته بندی ها</h1>
        //                 <table className="table-auto transition-all" >
        //                     <thead className="!py-2">
        //                         <tr className=" border-b border-black">
        //                             <th className="py-3">#</th>
        //                             <th className="py-3">عنوان</th>
        //                             <th className="py-3">نوع</th>
        //                             <th className="py-3">عملیات</th>
        //                         </tr>
        //                     </thead>
        //                     {
        //                         !isLoading &&
        //                         <tbody>
        //                             {
        //                                 data?.data?.length ?
        //                                     categoriesData?.data?.map(el => (
        //                                         <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
        //                                             <td className="text-center py-5" >{el.id}</td>
        //                                             <td className="text-center py-5" > {el.title}</td>
        //                                             <td className="text-center py-5 " >
        //                                                 <div className="bg-[#2196f3] py-2 text-white rounded-[1rem]">
        //                                                     {el.type === "course" ? "دوره" : "سرور"}
        //                                                 </div>
        //                                             </td>
        //                                             <td className="text-center py-5" >
        //                                                 <div className="flex justify-evenly items-center">
        //                                                     <div className=" cursor-pointer" onClick={() => naviagte("/super-admin/categories/edit/" + el.id)}><Edit width={"20"} height="20" /></div>
        //                                                     <div className=" cursor-pointer" onClick={() => {setSelectedData(el);setIsDeleteModalOpen(true);}}><Delete width={"20"} height="20" /></div>
        //                                                 </div>
        //                                             </td>
        //                                         </tr>
        //                                     ))
        //                                     :
        //                                     <div>
        //                                         <p>هیچ دسته بندی پیدا نشد</p>
        //                                     </div>
        //                             }
        //                         </tbody>
        //                     }
        //                 </table>
        //                 {
        //                     isLoading && <Loading />
        //                 }
        //             </div>
        //         </div>
        //     </div>
        // </Layout>
    )
}

export default Categories